import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { useTranslation } from 'react-i18next'

import TableBackdrop from '../../../TableUI/TableBackdrop'
import {
    Backdrop,
    CircularProgress,
    Link,
    Typography
} from '@mui/material'
import DatetimeValue from '../../../TableUI/DatetimeValue'
import TableActions from '../../../TableUI/TableActions'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered'
import DownloadIcon from '@mui/icons-material/Download'
import CurrencyValue from '../../../TableUI/CurrencyValue'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { useNavigate } from 'react-router-dom'


const styles = () => ({
    root: {
        width: '100%',
        overflowX: "auto",
    }, table: {
        minWidth: 650,
    }
})

export default function GroupedCashoutsTable({
    data,
    loading = false,
    working,
    setCurrentData,
    handleConfirm,
    handleCancel,
    handleDownload,
    hasPermissions
}) {
    const { t } = useTranslation()

    const navigate = useNavigate()

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', fontWeight: 800, zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={working}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <TableContainer className={styles.root}>
                <Table className={styles.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('Nº')}</TableCell>
                            <TableCell>{t('Group ID')}</TableCell>
                            <TableCell align="center">{t('Nº Cashouts')}</TableCell>
                            <TableCell align="right">{t('Total')}</TableCell>
                            <TableCell align="center">{t('Currency')}</TableCell>
                            <TableCell align="center">{t('Process date')}</TableCell>
                            <TableCell>&nbsp;</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && data.length ? data.map((row, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <Typography noWrap>{idx + 1}</Typography>
                                </TableCell>
                                <TableCell>
                                    <Link style={{ cursor: 'pointer' }} onClick={() => setCurrentData(row)}>{row.group_id}</Link>
                                </TableCell>
                                <TableCell align="center">{row.data?.length}</TableCell>
                                <TableCell align="right">
                                    <CurrencyValue amount={row.total} currency={row.currency} />
                                </TableCell>
                                <TableCell align="center">{row.currency}</TableCell>
                                <TableCell align="center">
                                    <DatetimeValue date={row.updated_at} />
                                </TableCell>
                                <TableCell>
                                    <TableActions actions={[
                                        {
                                            id: `details-${row.id}`,
                                            handleClick: () => { setCurrentData(row) },
                                            icon: <FormatListNumberedIcon />,
                                            title: t('Cashout list')
                                        },
                                        {
                                            id: `download-${row.id}`,
                                            handleClick: () => (handleDownload(row.group_id)),
                                            icon: <DownloadIcon />,
                                            title: t('Download TXT'),
                                            show: hasPermissions
                                        },
                                        {
                                            id: `complete-${row.id}`,
                                            handleClick: () => (handleConfirm({
                                                group_id: row.group_id
                                            })),
                                            icon: <CheckCircleOutlineIcon />,
                                            title: t('Confirm all Cashouts'),
                                            show: hasPermissions
                                        },
                                        {
                                            id: `cancel-${row.id}`,
                                            handleClick: () => (handleCancel({
                                                group_id: row.group_id
                                            })),
                                            icon: <RestartAltIcon />,
                                            title: t('Cancel all Cashouts'),
                                            show: hasPermissions
                                        },
                                        {
                                            id: `upload-${row.id}`,
                                            handleClick: () => navigate(`/cashouts/upload/${row.group_id}`),
                                            icon: <CloudUploadIcon />,
                                            title: t('Upload bank response'),
                                            show: hasPermissions
                                        }
                                    ]} />
                                </TableCell>
                            </TableRow>
                        )) : <TableRow>
                            {
                                loading ? <TableBackdrop open={loading} /> : <TableCell sx={{ textAlign: 'center' }} colSpan={100}>{t('No records found')}</TableCell>
                            }
                        </TableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}
